import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconX: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.06667"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12 4L4 12"
    />
    <path
      d="M4 4L12 12"
    />
  </svg>
);

export {
  IconX,
};
